import { Component, Input } from "@angular/core";
import { DiscussionVote, VoterListConfig } from "../../../../../models";

@Component({
  selector: "voter-preview",
  templateUrl: "./voter-preview.component.html",
  styleUrls: [
    "./voter-preview.component.scss",
    "../../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class VoterPreviewComponent {
  private defaultUserImg: string =
    "../../../../../../../assets/images/uMuzi/african-mask.png";

  @Input() query: VoterListConfig;
  @Input() vote: DiscussionVote;
}
